
  import Cookies from 'js-cookie';
  import { defineComponent, inject, onMounted, ref, watch } from 'vue';
  import { ILazyLoadInstance } from 'vanilla-lazyload';

  const DAYS_IN_MONTH = 31;
  const DAYS_IN_YEAR = 365;
  const COOKIES_KEY_ACCEPTED = 'cookiesAccepted';
  const COOKIES_KEY_CLOSED = 'cookiesClosed';
  const CLASS_MEDIA_OVERLAY = 'cookies-info-overlay';

  export default defineComponent({
    props: {
      title: {
        type: String,
        default: 'Cookie policy'
      },
      text: {
        type: String,
        default: 'We use cookies to ensure the best experience on the website.'
      },
      closeLabel: {
        type: String,
        default: 'Close'
      },
      acceptLabel: {
        type: String,
        default: 'Accept'
      },
      enableMessage: {
        type: String,
        default: 'Please enable cookies to view this content'
      }
    },
    setup(props) {
      const cookiesAccepted = ref(Cookies.get(COOKIES_KEY_ACCEPTED) === '1');
      let cookiesClosed = ref(Cookies.get(COOKIES_KEY_CLOSED) === '1');
      const lazyLoad: ILazyLoadInstance | undefined = inject('lazyLoad');

      function allowIFrames() {
        document.body.querySelectorAll(`.${CLASS_MEDIA_OVERLAY}`).forEach((message) => {
          message.parentNode?.removeChild(message);
        });
        document.body.querySelectorAll('iframe').forEach((iframe) => {
          iframe.setAttribute('lazy', 'true');
          iframe.style.display = 'block';
        });
      }

      function allowScripts() {
        for (const script of Array.from(document.scripts)) {
          if (script.type.toLowerCase() === 'text/plain') {
            const clonedScript = script.cloneNode(true) as HTMLScriptElement;
            const oldType = clonedScript.getAttribute('data-type');
            if (oldType) {
              clonedScript.setAttribute('type', oldType);
            } else {
              clonedScript.removeAttribute('type');
            }
            clonedScript.removeAttribute('data-type');
            script.parentNode?.replaceChild(clonedScript, script);
          }
        }
      }

      function disableIFrames() {
        const pTag = document.createElement('p');
        pTag.innerHTML = props.enableMessage;
        pTag.classList.add(`${CLASS_MEDIA_OVERLAY}-text`);
        const divTag = document.createElement('div');
        divTag.classList.add(CLASS_MEDIA_OVERLAY);
        divTag.appendChild(pTag);
        document.body.querySelectorAll('iframe').forEach((iframe) => {
          iframe.parentNode?.insertBefore(divTag.cloneNode(true), iframe);
          iframe.style.display = 'none';
        });
        document.body.querySelectorAll(`.${CLASS_MEDIA_OVERLAY}-text`).forEach((overlayText) => {
          overlayText.addEventListener('click', () => {
            cookiesClosed.value = false;
          });
        });
      }

      onMounted(() => {
        if (!cookiesAccepted.value) {
          disableIFrames();
        }
      });

      watch(cookiesAccepted, (accepted) => {
        if (accepted) {
          allowIFrames();
          allowScripts();
        } else {
          disableIFrames();
        }
        if (lazyLoad) {
          lazyLoad.update();
        }
      });

      return {
        cookiesAccepted,
        cookiesClosed
      };
    },
    methods: {
      accept() {
        this.cookiesClosed = true;
        Cookies.set(COOKIES_KEY_CLOSED, '1', {
          expires: DAYS_IN_YEAR,
          sameSite: 'strict',
          secure: true
        });
        this.cookiesAccepted = true;
        Cookies.set(COOKIES_KEY_ACCEPTED, '1', {
          expires: DAYS_IN_YEAR,
          sameSite: 'strict',
          secure: true
        });
      },

      close() {
        this.cookiesClosed = true;
        Cookies.set(COOKIES_KEY_CLOSED, '1', {
          expires: DAYS_IN_MONTH,
          sameSite: 'strict',
          secure: true
        });
      }
    }
  });
